import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M2.917 7A4.083 4.083 0 0 1 7 2.917c1.126 0 2.145.455 2.884 1.192L8.167 5.827l4.083.006V1.75l-1.541 1.534A5.25 5.25 0 0 0 7 1.75 5.25 5.25 0 0 0 1.75 7 5.25 5.25 0 0 0 7 12.25 5.25 5.25 0 0 0 12.25 7h-1.167A4.083 4.083 0 0 1 7 11.083 4.083 4.083 0 0 1 2.917 7Z"
	})
});
export default SvgReload;
